module.exports = __webpack_public_path__ + "img/eg-3.02373107.jpg";